import { produce } from 'immer'
import { mountStoreDevtool } from 'simple-zustand-devtools'
import { create } from 'zustand'

type NewActiveDirectoryFormState = {
	isFormValid: boolean
	formValues: Record<string, any>
}

type NewActiveDirectoryFormActions = {
	actions: {
		clearFormValues: () => void
		setFormValues: (fieldName: string, value: any) => void
		setFormValidity: (isValid: boolean) => void
	}
}

const initialFormValues = {}

const newAccessManagementFormStore = create<
	NewActiveDirectoryFormState & NewActiveDirectoryFormActions
>((set, _get) => ({
	isFormValid: false,
	formValues: initialFormValues,
	actions: {
		clearFormValues: () => set(() => ({ formValues: initialFormValues })),
		setFormValidity: (isValid) => set(() => ({ isFormValid: isValid })),
		setFormValues: (fieldName, value) =>
			set((state) =>
				produce(state, (draft) => {
					draft.formValues[fieldName] = value
				})
			)
	}
}))

export const useNewActiveDirectoryFormStore = () =>
	newAccessManagementFormStore((state) => state)

if (process.env.NODE_ENV !== 'production') {
	mountStoreDevtool(
		'NewAccessManagementFormStore',
		newAccessManagementFormStore
	)
}
